import eventRepo  from '../services/events';
import courseRepo from '../services/courses';

export const TOGGLE_EVENT_DETAIL_ACCORDION    = 'TOGGLE_EVENT_DETAIL_ACCORDION';
export const EVENT_DETAIL_REFRESHED           = 'EVENT_DETAIL_REFRESHED';
export const EVENT_DETAIL_SHOW_RESOURCE_PACKS = 'EVENT_DETAIL_SHOW_RESOURCE_PACKS';
export const RESET_EVENT_DETAIL               = 'RESET_EVENT_DETAIL';

export function resetEvent() {

    return {
        type: RESET_EVENT_DETAIL
    };
}

export function showResourcePacks(packs) {

    return {
        type: EVENT_DETAIL_SHOW_RESOURCE_PACKS,
        packs
    };
}

export function toggleAccordion(accordionKey) {

    return {
        type: TOGGLE_EVENT_DETAIL_ACCORDION,
        accordionKey
    };
}

export function refreshCourse(courseId) {

    return (dispatch) => {

        function getSuccess(response) {

            dispatch(dataRefreshed(response.data.data));
        }

        courseRepo.getOne(courseId)
            .then(getSuccess);
    };
}

export function refreshEvent(eventId) {
    
    return (dispatch) => {

        function getSuccess(response) {

            dispatch(dataRefreshed(response.data.data));
        }
        
        eventRepo.getOne(eventId)
            .then(getSuccess);
    };
}

export function dataRefreshed(model) {
    
    return {
        type: EVENT_DETAIL_REFRESHED,
        model
    };
}


// WEBPACK FOOTER //
// ./actions/detailPage.js